import React, { Component } from "react";
import CellWithTwoLabels from "../shared/groups/CellWithTwoLabels";
import Content from "../../content/Content";
import style from "../../assets/css/modules/claims/claims-summary-desktop-row.css";
import { withRouter } from "react-router-dom";
import { API_ROOT } from "../../api-config";
import { connect } from "react-redux";
import Contentify from "../../content/Contentify";
import Store from "../../content/Store";
import FileDownload from "../download/FileDownload";
import FileDownloadRetryLink from "../download/FileDownloadRetryLink";

export class ClaimsSummaryFormat2DesktopRow extends Component {
  static content = Store.Claims;

  constructor(props) {
    super(props);

    this.state = {
      retryUrl: null,
      retryUrlData: null
    };
  }

  render() {
    let amountContent;
    const {
      content,
      isInternational,
      claimSummary,
      membershipNumber,
      selectedMemberSecurityId
    } = this.props;

    if (typeof isInternational === "boolean" && !isInternational) {
      amountContent = (
        <React.Fragment>
          <div className={"col " + style.removeLeftPadding}>
            <CellWithTwoLabels
              topLabel={content.AmountClaimedLabel}
              bottomLabel={claimSummary.AmountClaimed}
            />
          </div>
          <div className={"col-1 " + style.removeLeftPadding}>
            <CellWithTwoLabels
              topLabel={content.AmountPaidLabel}
              bottomLabel={claimSummary.AmountPaid}
            />
          </div>
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        <div className={"col-1 " + style.paddingRightForIcon}>
          <i
            className={
              "icon-claims-document " +
              style.claimRowIcon +
              " " +
              style.floatIconRight
            }
          />
        </div>
        <div className={"col-3 " + style.removeLeftPadding}>
          <CellWithTwoLabels
            topLabel={content.ClaimNumberLabel}
            bottomLabel={claimSummary.ClaimNumber}
          />
        </div>
        <div className={"col " + style.removeLeftPadding}>
          <CellWithTwoLabels
            topLabel={content.AvailableDatelabel}
            bottomLabel={claimSummary.AvailableDate}
          />
        </div>
        {amountContent}
        <div
          className={
            style.centeredVertically +
            " col-3 text-right " +
            style.benefitStatementLink
          }
        >
          <FileDownload
            url={`${API_ROOT}/benefitstatement?benefitStatementId=${
              claimSummary.BenefitStatementId
            }&membershipNumber=${encodeURIComponent(
              membershipNumber
            )}&memberSecurityId=${selectedMemberSecurityId}`}
            openInNewTab
            setRetryFileUrl={(url, urlData) =>
              this.setState({
                retryUrl: url,
                retryUrlData: urlData
              })
            }
          >
            <i className={"icon-download " + style.benefitStatementIcon} />
            <Content name={content.BenefitStatementPdfLinkLabel} />
          </FileDownload>
        </div>
        {this.state.retryUrl && this.state.retryUrlData ? (
          <div className="col-12">
            <FileDownloadRetryLink
              url={this.state.retryUrl}
              urlData={this.state.retryUrlData}
              fileName={`${content.BenefitStatementPdfLinkLabel}  ${claimSummary.BenefitStatementId}.pdf`}
            />
          </div>
        ) : null}
      </React.Fragment>
    );
  }
}

export const mapStateToClaimsSummaryFormat2DesktopRow = ({
  claimsReducer,
  policyReducer
}) => {
  let selectedPolicy = claimsReducer.selectedPolicy;

  return {
    selectedMemberSecurityId:
      selectedPolicy &&
      selectedPolicy.selectedClaimMember &&
      selectedPolicy.selectedClaimMember.SecurityId,
    isInternational:
      policyReducer.selectedPolicy &&
      policyReducer.selectedPolicy.IsInternational
  };
};

export default withRouter(
  connect(mapStateToClaimsSummaryFormat2DesktopRow)(
    Contentify(ClaimsSummaryFormat2DesktopRow)
  )
);
